<template>
  <div>
    <div class="mb-1 d-flex flex-wrap" v-if="selected.length > 0">
      <span v-for="(tag, index) in selected" :key="tag.id" class="custom-tag mr-1" :style="getBadgeStyle(tag.color)">
        <span class="mr-1">{{ tag.name }}</span>
        <font-awesome-icon v-if="!isDisabled" icon="times" style="cursor: pointer;" @click.stop="removeTag(index)"/>
      </span>
    </div>

    <b-input-group class="position-relative">
      <b-form-input
        id="input-recruit-tags"
        size="sm"
        :disabled="isDisabled"
        v-model="query"
        placeholder="Поиск тега"
        autocomplete="off"
        @focus="onFocusIn"
        @blur="onFocusOut"
      />
      <b-input-group-append>
        <b-btn size="sm" variant="secondary" :disabled="isDisabled" @click.stop="onClearSelected"><font-awesome-icon icon="times-circle"/></b-btn>
      </b-input-group-append>

      <b-list-group
        class="autocomplete-input position-absolute w-100 shadow-sm"
        style="z-index: 1050; top: 0; max-height: 200px; overflow-y: auto;"
        v-if="isFocus"
      >
        <b-list-group-item
          v-for="item in filteredItems"
          :key="item.id"
          @mousedown.prevent="selectTag(item)"
          button
          class="text-small"
        >
          <span class="custom-tag mr-1" :style="getBadgeStyle(item.color)">
            <span class="mr-1">{{ item.name }}</span>
          </span>
        </b-list-group-item>
        <b-list-group-item v-if="filteredItems.length === 0 && query" disabled>
          <small>Ничего не найдено</small>
        </b-list-group-item>
      </b-list-group>
    </b-input-group>
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import helpers from "../../../utilites/helpers";
  import {debounce} from "lodash";

export default {
  name: "RecruitTagMultiSelect",
  mixins: [
    catalogs,
    helpers
  ],
  props: {
    isDisabled: { type: Boolean, default: false },
    value: { type: Array, default: () => [] }
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      selected: []
    }
  },
  created() {
    this.debouncedSearch = debounce(this.getItems, 200);
  },
  beforeDestroy() {
    this.debouncedSearch.cancel();
  },
  computed: {
    filteredItems() {
      if (!this.items) return [];

      return this.items.filter(item => {
        return !this.selected.some(selected =>
          (selected.id === item.id)
        );
      });
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.selected = Array.isArray(newVal) ? [...newVal] : [];
      }, immediate: true
    },
    'query': {
      handler: async function (newValue) {
        const lowerQuery = (newValue).toLowerCase();
        this.debouncedSearch(lowerQuery);
      }
    }
  },
  methods: {
    async onFocusIn() {
      if (this.query === "" && this.items.length === 0) {
        await this.getItems(this.query);
      }
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;
    },
    selectTag(item) {
      this.selected.push(item);
      this.query = "";
      this.$emit('onSelect', this.selected);
    },
    removeTag(index) {
      if (this.isDisabled) return;
      this.selected.splice(index, 1);
      this.$emit('onSelect', this.selected);
    },
    onClearSelected() {
      this.selected = [];
      this.$emit('onSelect', this.selected);
    },
    async getItems(query) {
      const result = await this.getRecruitTagsSearch(query);
      if (result && result.data) {
        this.items = result.data;
      }
      return [];
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/RecruitTags/RecruitTagMultiSelect.vue